import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Enum from "csi/heading/Enum";
import stateColorResolver from "csi/heading/stateColorResolver";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const EnumStateColorRenderer = declare(Enum, {
	// should be rendered as upper case text
	capitalized: true,

	/**
	 * @override
	 * Apply styling to enum headings
	 */
	_getRenderCSS(ctx: Context, h: Heading) {
		const node = ctx.getNode();
		const attr = h.m_id;

		if (!node) {
			return this.inherited(arguments);
		}

		const enumVal = xml.enumGetText(node[attr]);
		return this.inherited(arguments) + " " + stateColorResolver.getStateCssByIndexFromCommon(enumVal);
	},
});

export = EnumStateColorRenderer;
